import { useCallback, useEffect, useReducer } from 'react';

import { SportManager } from '@atlas/core';

import { sportService } from 'common/constants';
import { useSelectionsContext } from 'components/SportsbookSelections/SelectionsContext';

const { LIVE, PREMATCH } = sportService;

const reducer = (state, { payload, type }) => {
  switch (type) {
    case 'SET_STATE': {
      return {
        ...state,
        ...payload,
      };
    }
    default: {
      return state;
    }
  }
};

const defaultState = {
  isLoading: true,
  selections: [],
  tournaments: [],
};

const useSelections = ({ selectedSelectionId }) => {
  const [state, dispatch] = useReducer(reducer, defaultState);
  const { isLoading: isSelectionsLoading, selections } = useSelectionsContext();

  const setState = useCallback(payload => {
    dispatch({ payload, type: 'SET_STATE' });
  }, []);

  const setTournaments = useCallback(
    tournaments => {
      setState({ tournaments });
    },
    [setState],
  );

  const setIsLoading = useCallback(
    isLoading => {
      setState({ isLoading });
    },
    [setState],
  );

  useEffect(() => {
    if (!selectedSelectionId) return;
    setIsLoading(true);

    SportManager.findEvents({
      filter: {
        selectionId: Number(selectedSelectionId),
        sportServices: [LIVE, PREMATCH],
      },
    })
      .then(({ data: tournaments }) => {
        const formattedTournaments = Object.values(tournaments).map(tournament => {
          const { events } = tournament;
          const arrEvents = Object.values(events).sort((a, b) => a.position - b.position);
          // Adding missing tournament info
          const id = arrEvents[0].tournamentId;
          const sportId = arrEvents[0].sportId;
          const categoryId = arrEvents[0].categoryId;
          const categoryName = arrEvents[0].categoryName;
          const sportName = arrEvents[0].sportName;
          const name = arrEvents[0].tournamentName;

          return {
            categoryId,
            categoryName,
            events: arrEvents,
            id,
            name,
            sportId,
            sportName,
          };
        });

        setTournaments(formattedTournaments);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [selectedSelectionId, setIsLoading, setTournaments]);

  return {
    ...state,
    isSelectionsLoading,
    selections,
    setIsLoading,
    setTournaments,
  };
};

export default useSelections;
